module.exports = __webpack_public_path__ + "img/account-stat-widget.5a335c1d.png";